import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'filterForms' })
export class FilterFormsCollectionPipe implements PipeTransform {
    transform(data: any, key: string, search: string | number, returnVacio: boolean): any {
        if (returnVacio && !search) return [];
        if (!data) return [];
        if (!search && !returnVacio) return data;
        return data.filter((x: any) => x.get(key)?.value?.toString().toLowerCase().includes(search.toString().toLowerCase()));
    }
}
